import React, { FC } from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import { useI18n } from '~Hooks';
import ZoneSelection from './ZoneSelection';

const Zone: FC = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Settings.Zone')}>
      <ZoneSelection />
    </HandyPageWrapper>
  );
};

export default Zone;
